import type { Plantilla } from '@/types/wizard';
import styles from './TemplateCard.module.css';

interface Props {
  plantilla: Plantilla;
  isSelected: boolean;
  onClick: () => void;
}

export const TemplateCard = ({ plantilla, isSelected, onClick }: Props) => {
  return (
    <div className={`${styles.card} ${isSelected ? styles.selected : ''}`} onClick={onClick}>
      <div className={styles.preview}>
        <img
          src={plantilla.preview_image}
          alt={plantilla.name}
          className={styles.previewImage}
          draggable={false}
        />
        <span className={styles.slideCount}>{plantilla.slide_count} slides</span>
      </div>
      <div className={styles.info}>
        <h3 className={styles.name}>{plantilla.name}</h3>
        <p className={styles.description}>{plantilla.description}</p>
        <div className={styles.tags}>
          {plantilla.tags.map((tag) => (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
